import { defineComponent as _defineComponent } from 'vue'
import { CardData, CardType } from '~/composables/useCardData';
import { useCardPrice } from '~/composables/useCardPrice';

export default /*#__PURE__*/_defineComponent({
  __name: 'CardPriceTag',
  props: {
    item: null,
    type: null
  },
  setup(__props: any) {

const props = __props as {
  item: CardData;
  type: CardType;
};


const { isFree } = useCardPrice(props.item);

return { __sfc: true,props, isFree }
}

})